"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectIE = exports.composeName = exports.ScrollTo = exports.MinimumTimeOnCall = exports.DatePresets = void 0;
exports.formatDate = formatDate;
exports.formatPhoneNumber = exports.formatModeratorSearchItems = void 0;
exports.getAge = getAge;
exports.stripHtml = exports.resolveRender = exports.personName = exports.personInitials = exports.isSafari = exports.hasNoCareTeam = exports.getStatesString = exports.getDateByPreset = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _scrollTo = _interopRequireDefault(require("antd/es/_util/scrollTo"));
var _ = require("./");
var _usaStates = require("./usaStates.utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getFullStateName = _usaStates.UsaStatesUtils.getFullStateName;
var composeName = function composeName() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
  return names.filter(function (n) {
    return !!n;
  }).map(function (n) {
    return n.trim();
  }).map(function (n) {
    if (n.toLowerCase() === n || n.toUpperCase() === n) {
      return (0, _lodash.capitalize)(n);
    }
    // If name is not all lowercase or uppercase,
    // assume it is properly capitalized
    return n;
  }).filter(function (n) {
    return !!n;
  }).join(separator);
};
exports.composeName = composeName;
var personName = function personName() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    nickName = _ref.nickName;
  return composeName([firstName, lastName], ' ').trim() || nickName;
};
exports.personName = personName;
var personInitials = function personInitials(name) {
  if (!name) {
    return '';
  }

  // Matches something like Shiny_Seashell_754
  // (first two words capitalized, at least one number after the second underscore)
  var defaultPatientNicknameRegex = /^[a-zA-Z]+_[a-zA-Z]+_\d+$/;

  // Matches something like John Smith
  // Depends on current implementation where
  // patient nicknames are not allowed to have spaces
  var personNameRegex = /\w+ \w+/;
  if (defaultPatientNicknameRegex.test(name)) {
    // If name is Shiny_Seashell_754, return SS
    return name.split('_').reduce(function (initials, word, index) {
      if (index < 2) {
        return initials + word[0];
      }
      return initials;
    }, '');
  }
  if (personNameRegex.test(name)) {
    // If name is John Smith, return JS
    return name.split(' ').reduce(function (initials, word) {
      return initials + word[0];
    }, '');
  }
  return name[0]; // If name is anything else return first character
};
exports.personInitials = personInitials;
var detectIE = function detectIE() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }
  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  // let edge = ua.indexOf('Edge/');
  // if (edge > 0) {
  // Edge (IE 12+) => return version number
  // return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  // }

  // other browser
  return false;
};
exports.detectIE = detectIE;
var resolveRender = function resolveRender(callback) {
  if (detectIE()) {
    window.location.href = "".concat(process.env.REACT_APP_APPLICATION_URL, "/unsupported-browser");
  } else {
    callback();
  }
};
exports.resolveRender = resolveRender;
var isSafari = function isSafari(props) {
  var _ref2 = props || {},
    macOnly = _ref2.macOnly,
    mobileOnly = _ref2.mobileOnly;
  if (mobileOnly) {
    var _ua = _.mobileDetect.userAgent();
    return _ua === 'Safari';
  }
  var ua = navigator.userAgent;
  var conditions = [ua.indexOf('Safari/') > -1, ua.indexOf('Chrome/') < 0];
  if (macOnly) {
    conditions.push(ua.indexOf('Macintosh') > -1);
  }
  return conditions.reduce(function (result, cond) {
    return result && cond;
  }, true);
};
exports.isSafari = isSafari;
var stripHtml = function stripHtml(htmlString) {
  return htmlString.replace(/<[^>]+>/g, '');
};
exports.stripHtml = stripHtml;
var getStatesString = function getStatesString(licenses) {
  return licenses && licenses.length ? licenses.map(function (_ref3) {
    var state = _ref3.state;
    return getFullStateName(state);
  }).join(', ') : '';
};
exports.getStatesString = getStatesString;
var formatPhoneNumber = function formatPhoneNumber(value) {
  if (!value) {
    return value;
  }
  var removeNonDigitCharacters = function removeNonDigitCharacters(str) {
    return str.replace(/\D/g, '');
  };
  var groupDigitsIntoPhoneNumberGroups = function groupDigitsIntoPhoneNumberGroups(str) {
    return str.match(/^(\d{1,3})(\d{1,3})?(\d{1,4})?(.*)/) || [];
  };
  var newValue = removeNonDigitCharacters(value);
  var groups = groupDigitsIntoPhoneNumberGroups(newValue);
  var excessValue = groupDigitsIntoPhoneNumberGroups(value)[4];
  return "".concat(groups[1] ? "(".concat(groups[1]) : '').concat(groups[2] ? ") ".concat(groups[2]) : '').concat(groups[3] ? "-".concat(groups[3]) : '').concat(excessValue ? excessValue : '');
};
exports.formatPhoneNumber = formatPhoneNumber;
function formatDate(date) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref4$dateFormat = _ref4.dateFormat,
    dateFormat = _ref4$dateFormat === void 0 ? 'MM/DD/YYYY' : _ref4$dateFormat,
    _ref4$withTime = _ref4.withTime,
    withTime = _ref4$withTime === void 0 ? false : _ref4$withTime,
    _ref4$timeFormat = _ref4.timeFormat,
    timeFormat = _ref4$timeFormat === void 0 ? 'HH:mm:ss' : _ref4$timeFormat,
    _ref4$utc = _ref4.utc,
    utc = _ref4$utc === void 0 ? false : _ref4$utc;
  if (!date) {
    return '';
  }
  var format = withTime ? "".concat(dateFormat, " ").concat(timeFormat) : dateFormat;
  var adjustedDate = utc ? _momentTimezone.default.utc(date) : (0, _momentTimezone.default)(date);
  return adjustedDate.format(format);
}
function getAge(birthday) {
  return (0, _momentTimezone.default)().diff((0, _momentTimezone.default)(birthday), 'years');
}
var DatePresets = {
  Custom: 'Custom',
  Today: 'Today',
  Yesterday: 'Yesterday',
  Tomorrow: 'Tomorrow',
  LastWeek: 'Last week',
  NextWeek: 'Next week',
  Last30Days: 'Last 30 days',
  Next30Days: 'Next 30 days'
};
exports.DatePresets = DatePresets;
var getDateByPreset = function getDateByPreset(preset) {
  var startDate = '';
  var endDate = '';
  var today = (0, _momentTimezone.default)().format('YYYY-MM-DD');
  switch (preset) {
    case DatePresets.Today:
      startDate = today;
      endDate = (0, _momentTimezone.default)().add(1, 'days').format('YYYY-MM-DD');
      break;
    case DatePresets.Yesterday:
      startDate = (0, _momentTimezone.default)().subtract(1, 'days').format('YYYY-MM-DD');
      endDate = today;
      break;
    case DatePresets.Tomorrow:
      startDate = (0, _momentTimezone.default)().add(1, 'days').format('YYYY-MM-DD');
      endDate = (0, _momentTimezone.default)().add(2, 'days').format('YYYY-MM-DD');
      break;
    case DatePresets.LastWeek:
      startDate = (0, _momentTimezone.default)().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
      endDate = (0, _momentTimezone.default)().startOf('week').format('YYYY-MM-DD');
      break;
    case DatePresets.NextWeek:
      startDate = (0, _momentTimezone.default)().add(1, 'weeks').startOf('week').format('YYYY-MM-DD');
      endDate = (0, _momentTimezone.default)().add(2, 'weeks').startOf('week').format('YYYY-MM-DD');
      break;
    case DatePresets.Last30Days:
      startDate = (0, _momentTimezone.default)().subtract(30, 'days').format('YYYY-MM-DD');
      endDate = today;
      break;
    case DatePresets.Next30Days:
      startDate = (0, _momentTimezone.default)().add(1, 'days').format('YYYY-MM-DD');
      endDate = (0, _momentTimezone.default)().add(31, 'days').format('YYYY-MM-DD');
      break;
    default:
      break;
  }
  return {
    startDate: startDate,
    endDate: endDate
  };
};
exports.getDateByPreset = getDateByPreset;
var formatModeratorSearchItems = function formatModeratorSearchItems(users) {
  var showFullName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0, _lodash.filter)(users, function (user) {
    return !(0, _lodash.isEmpty)(user);
  }).map(function (user) {
    return {
      key: user.id,
      label: showFullName ? composeName([user.lastName, user.firstName]) : user.nickName
    };
  });
};

// Handles scrolling to the page top, or scrolling to a target element.
// As of 2021-05-14, these 2 scroll functions has been confirmed to work on the iOS simulator,
// and on Google Chrome on MacOS in these 3 different configurations:
// 1. Wide desktop
// 2. "Narrow" desktop (the back button being visible)
// 3. Real, or simulated (via Chrome DevTools) mobile device
// @BrandLibel

// Removed old windowIsDesktopWidth based logic from "target" scrolling after testing on MacOS/IOS/Android/Windows browsers
// This part of https://github.com/JoinMonument/frontend/pull/2730 seems to be working fine without it
// "top" part is working as it is, no big need to change it
// 2022-04-06, @TarasGumenyuk
exports.formatModeratorSearchItems = formatModeratorSearchItems;
var ScrollTo = {
  top: function top() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref5$isSmooth = _ref5.isSmooth,
      isSmooth = _ref5$isSmooth === void 0 ? true : _ref5$isSmooth;
    var mainHeaderWrapper = document.querySelector(_.MainHeaderWrapperClass);
    if (mainHeaderWrapper) {
      mainHeaderWrapper.scrollIntoView({
        behavior: isSmooth ? 'smooth' : 'auto',
        block: 'start'
      });
    } else {
      (0, _scrollTo.default)(0, {
        getContainer: function getContainer() {
          return document.querySelector('#root');
        },
        duration: isSmooth ? 450 : 1
      });
    }
  },
  /**
   * Scrolls to the target. Pass either selector String or element Element, but
   * not both.
   * @param object
   */
  target: function target(_ref6) {
    var _ref6$selector = _ref6.selector,
      selector = _ref6$selector === void 0 ? null : _ref6$selector,
      _ref6$element = _ref6.element,
      element = _ref6$element === void 0 ? null : _ref6$element,
      _ref6$isSmooth = _ref6.isSmooth,
      isSmooth = _ref6$isSmooth === void 0 ? true : _ref6$isSmooth,
      block = _ref6.block;
    if (selector && element) {
      throw new Error('Pass either selector or element, but not both');
    }
    var target = selector ? document.querySelector(selector) : element;
    target === null || target === void 0 ? void 0 : target.scrollIntoView({
      behavior: isSmooth ? 'smooth' : 'auto',
      block: block
    });
  }
};
exports.ScrollTo = ScrollTo;
var MinimumTimeOnCall = {
  therapistTime: 420,
  physicianTime: 300
};
exports.MinimumTimeOnCall = MinimumTimeOnCall;
var hasNoCareTeam = function hasNoCareTeam(clinicians) {
  return clinicians && (0, _lodash.isEmpty)(clinicians);
};
exports.hasNoCareTeam = hasNoCareTeam;